import { render, staticRenderFns } from "./debtorDetail.vue?vue&type=template&id=36012495&"
import script from "./debtorDetail.vue?vue&type=script&lang=js&"
export * from "./debtorDetail.vue?vue&type=script&lang=js&"
import style0 from "./debtorDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports